// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".primary-button[data-v-65d5dcb9]{max-height:32px;min-height:32px}.icon-star[data-v-65d5dcb9],.icon-star-empty[data-v-65d5dcb9]{color:#fcb602}@media(min-width:992px){div[data-v-65d5dcb9]{background-color:#fff;padding:25px 30px 20px}.active-button[data-v-65d5dcb9]{background-color:#2f8e97;color:#fff!important}.icon-star[data-v-65d5dcb9],.icon-star-empty[data-v-65d5dcb9]{color:#ffeb3b}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
